import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Head from "next/head";
import { useAppContext } from "../_context";

const TermsAndConditions = () => {
  const [{ tx }] = useAppContext();

  return (
    <>
      <Head>
        <title>RacketPal - {tx["Terms & Conditions"]}</title>
      </Head>
      <Container>
        <Row>
          <Col md={8} className="m-auto section-padding-y">
            <div>
              <p className="c19">
                <h1>
                  <span className="c5">
                    RACKETPAL PLATFORM: MASTER TERMS OF SERVICE
                  </span>
                </h1>
              </p>
              <p className="c20">
                <span className="c0">
                  These master terms of service (together with the documents,
                  information and policies that are referred to in these master
                  terms of service) (
                </span>
                <span className="c6 fw-bold">'Terms'</span>
                <span className="c0">
                  ) set out the legal terms that apply to your (
                </span>
                <span className="c6 fw-bold">'Customer'</span>
                <span className="c0">
                  ) access to and use of RacketPal's services, including the
                  Platform (as defined below) and RacketPal Premium (as defined
                  below) (together the{" "}
                </span>
                <span className="c6 fw-bold">'Services'</span>
                <span className="c0">
                  ), whether operated by RacketPal or on its behalf. These Terms
                  do not apply to RacketPal's generally available marketing
                  websites available at: (i) www.racketpal.co.uk; (ii)
                  www.racketpal.cz; (iii) www.racketpal.io; (iv)
                  www.racketpal.net; and (v) www.racketpal.tech.
                </span>
              </p>
              <p className="c20">
                <span className="c0">
                  Please read these Terms carefully. Customer's use of and
                  access to the Services is conditional on its compliance with
                  and acceptance of these Terms. &nbsp; &nbsp;
                </span>
              </p>
              <ol className="c7 lst-kix_list_7-0 start" start={1}>
                <h4 className="mt-5">
                  <li className="c13 li-bullet-0">
                    <span className="c5">About RacketPal</span>
                  </li>
                </h4>
              </ol>
              <ol className="c7 lst-kix_list_7-1 start" start={1}>
                <li className="c3 li-bullet-1">
                  <span className="c0">These Terms are with </span>
                  <b>
                    <span className="c6 fw-bold">RacketPal</span>
                  </b>
                  <span className="c0">
                    , the trading name of RacketPal Ltd, a company registered in
                    England &amp; Wales under Company Registration Number
                    11818671. RacketPal's address is: 103 Barney Close, London,
                    SE7 8ST.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    Customer can contact RacketPal via email at{" "}
                  </span>
                  <span className="c14">
                    <a
                      className="c8 text-primary"
                      href="mailto:support@racketpal.co.uk">
                      support@racketpal.co.uk
                    </a>
                  </span>
                  <span className="c0">
                    &nbsp;or via the relevant channels in the Platform.{" "}
                  </span>
                </li>
                <li className="c3 li-bullet-2">
                  <span className="c0">
                    If RacketPal needs to contact Customer, it will do so using
                    the email address Customer has provided as its current
                    contact email for its Account (as defined below).
                  </span>
                </li>
              </ol>
              <ol className="c7 lst-kix_list_7-0" start={2}>
                <h4 className="mt-5">
                  <li className="c13 li-bullet-0">
                    <span className="c5">
                      Access to and use of the Platform
                    </span>
                  </li>
                </h4>
              </ol>
              <ol className="c7 lst-kix_list_7-1 start" start={1}>
                <li className="c11 li-bullet-1">
                  <span className="c0">The </span>
                  <span className="fw-bold">'Platform' </span>
                  <span className="c0">
                    means the software platform known as 'RacketPal' - currently
                    available via{" "}
                  </span>
                  <span className="c14">
                    <a
                      className="c8 text-primary"
                      href="https://www.racketpal.co.uk/"
                      target="_blank"
                      rel="noreferrer">
                      www.racketpal.co.uk
                    </a>
                  </span>
                  <span className="c0">
                    &nbsp;or via the Apple store or Google Play store (each an '
                  </span>
                  <span className="c6 fw-bold">App Store</span>
                  <span className="c0">
                    '). RacketPal Premium is made available to Customer via the
                    Platform.
                  </span>
                </li>
                <li className="c11 li-bullet-1">
                  <span className="c0">
                    RacketPal provides the Platform to Customer on the basis of
                    these Terms. These Terms may be updated by RacketPal from
                    time to time (due to, for example, changing technologies, a
                    change in the law or RacketPal introducing new product
                    features) by RacketPal posting the updated Terms on the
                    Platform (RacketPal will use reasonable endeavours to
                    provide Customer with advance notice). When Customer
                    accesses the Platform at any time in the future, such
                    updated Terms then in force shall apply to its use of the
                    Platform.
                  </span>
                </li>
                <li className="c11 li-bullet-1">
                  <span className="c0">
                    RacketPal may update and change the Platform from time to
                    time (without prior notification to Customer) to reflect its
                    users’ needs and its business priorities. RacketPal may, in
                    its sole discretion, discontinue or modify any features of
                    the Platform from time-to-time without prior notice.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    RacketPal tries to make sure that content on the Platform is
                    accurate and up-to-date, but cannot promise that they will
                    be. RacketPal does not guarantee that the Platform will
                    always be available or be uninterrupted. RacketPal may
                    suspend or restrict of availability of all or any part of
                    the Platform for business or operational reasons. Any
                    support provided to Customer is for information purposes
                    only. RacketPal reserves the right to make changes to the
                    Platform at any time; or not to reply to any queries; or not
                    provide support in connection with the Platform.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    In order to use the Platform Customer will need to register
                    for an account on the Platform (your '
                  </span>
                  <span className="c6 fw-bold">Account</span>
                  <span className="c0">
                    '). By creating an Account Customer confirms that: (i)
                    Customer is at least 13 years old; and (ii) any information
                    provided to register for an Account is accurate.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    Your Account cannot be shared or used by more than one
                    individual at the same time. Individual Customers are not
                    permitted to register or operate more than one Account at
                    any time.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    RacketPal is not responsible for websites it links to via
                    the Platform and it has no control over the contents of
                    those sites or resources. Where the Platform contains links
                    to other sites and resources provided by third parties,
                    these links are provided for your information only and
                    Customer acknowledge that Customer access any such
                    third-party websites at your own risk. RacketPal makes no
                    representation or commitment and shall have no liability or
                    obligation whatsoever in relation to the content or use of,
                    or correspondence with, any such third-party websites, or
                    any transaction completed therein, and/or any contract
                    entered into by Customer, with any such third party. Such
                    links should not be interpreted as approval by RacketPal of
                    those linked websites or information Customer may obtain
                    from them and Customer is responsible for reviewing any
                    terms and conditions for any linked websites.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    The Platform may include information and materials supplied
                    by third parties, our partners, and by other users of the
                    Platform. This information and these materials have not been
                    verified for accuracy or completeness, nor have they been
                    endorsed or approved by RacketPal. The views expressed by
                    third parties on the Platform do not necessarily represent
                    RacketPal's views or values.
                  </span>
                </li>
                <li className="c3 li-bullet-2">
                  <span className="c0">
                    RacketPal has no responsibility or liability for the
                    accuracy of means
                  </span>
                  <span className="c21">&nbsp;</span>
                  <span className="c0">
                    data and information provided by Customer to RacketPal in
                    connection with Customer's use of the Services ('
                  </span>
                  <span className="c6 fw-bold">Customer Data</span>
                  <span className="c0">
                    '), or data it receives from third parties.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    Under no circumstances will RacketPal be liable in any way
                    for any (i) Customer Data that is transmitted or viewed
                    while using the Services, (ii) errors or omissions in the
                    Customer Data, or (iii) any loss or damage of any kind
                    incurred as a result of the use of, access to, or denial of
                    access to Customer Data. &nbsp;
                  </span>
                </li>
                <li className="c3 li-bullet-2">
                  <span className="c0">
                    RacketPal does not guarantee that our Platform will be
                    secure or free from bugs or viruses.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    RacketPal reserves the right to decline or cancel an Account
                    registration at any time. RacketPal reserves the right to,
                    at any time, prevent Customer from using the Platform, your
                    Account and/or the Services, including where necessary
                    terminating or suspending your Account and/or terminating
                    these Terms, if it reasonably suspects that Customer is in
                    breach of these Terms and/or any applicable laws.
                  </span>
                </li>
                <li className="c3 li-bullet-2">
                  <span className="c0">
                    Customer may cancel your Account registration at any time by
                    contacting RacketPal using the contact details provided
                    above.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    All content on the Platform published by RacketPal is in the
                    English language. RacketPal will communicate with Customer
                    in English and cannot guarantee it will be able to
                    communicate with Customer in relation to any communications
                    made in any other language. Customer is recommended to use
                    the English language when using the Platform and any content
                    submitted by Customer in any other language may be removed
                    by RacketPal acting in its sole discretion.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    RacketPal may run promotions through the Platform from time
                    to time, which can be withdrawn at any time without notice.
                  </span>
                </li>
              </ol>
              <ol className="c7 lst-kix_list_7-0" start={3}>
                <h4 className="mt-5">
                  <li className="c9 c13 li-bullet-0">
                    <span className="c5">
                      Customer responsibilities when using the Platform
                    </span>
                  </li>
                </h4>
              </ol>
              <ol className="c7 lst-kix_list_7-1 start" start={1}>
                <li className="c11 c9 li-bullet-1">
                  <span className="c0">
                    Customer is not permitted to use the Platform for any
                    immoral, illegal, abusive, threatening, discriminatory or
                    harmful purposes, or in any way that harms the reputation of
                    RacketPal and/or its partners. Customer is not permitted to
                    use the Platform to cause harm, annoyance, inconvenience or
                    needless anxiety to any person. Customer is not permitted to
                    use obscene or vulgar language when using the Platform.
                    Customer is not permitted to post on the Platform any links
                    to third party websites containing any content that would
                    not be permitted to be posted directly on the Platform by
                    Customer under these Terms.
                  </span>
                </li>
                <li className="c11 li-bullet-1">
                  <span className="c0">
                    Customer must not misuse the Platform in a way that may
                    impair the performance, corrupt the content or otherwise
                    reduce the overall functionality of the Platform (including
                    using the Platform for unauthorised mass-communications,
                    such as "spam communications" or "junk mail"), or by
                    knowingly introducing viruses, trojans, worms, logic bombs
                    or other material that is malicious or technologically
                    harmful. Customer must not attempt to gain unauthorised
                    access to the Platform, the server on which the Platform is
                    stored or any server, computer or database connected to the
                    Platform. Customer must not attack the Platform via a
                    denial-of-service attack or a distributed denial-of service
                    attack. By breaching this provision, Customer would commit a
                    criminal offence. RacketPal will report any such breach to
                    the relevant law enforcement authorities and RacketPal will
                    co-operate with those authorities by disclosing your
                    identity to them. In the event of such a breach, Customer's
                    right to use the Platform will cease immediately. &nbsp;
                  </span>
                </li>
                <li className="c11 li-bullet-1">
                  <span className="c0">
                    In using the Platform, Customer agrees:
                  </span>
                </li>
              </ol>
              <ol className="c7 lst-kix_list_19-2 start" start={1}>
                <li className="c1 li-bullet-3">
                  <span className="c0">
                    to provide and maintain correct and up-to-date information
                    about yourself when Customer uses the Platform, including in
                    respect of your Account;
                  </span>
                </li>
                <li className="c1 li-bullet-3">
                  <span className="c0">
                    not to use the Platform for commercial purposes (including
                    any form of commercial advertising), or to commercially
                    exploit or otherwise make the Platform available to any
                    third party (except in accordance with these Terms);
                  </span>
                </li>
                <li className="c1 li-bullet-3">
                  <span className="c0">
                    not to access all or any part of the Platform in order to
                    build a product or service which competes with the Platform;
                  </span>
                </li>
                <li className="c1 li-bullet-3">
                  <span className="c0">
                    not to attempt to copy, modify, translate, adapt, create
                    derivative works of, display, transmit or distribute all or
                    any part of the Platform;
                  </span>
                </li>
                <li className="c1 li-bullet-3">
                  <span className="c0">
                    not to attempt to reverse compile, disassemble, reverse
                    engineer or otherwise reduce to human-perceivable form all
                    or any part of the Platform;
                  </span>
                </li>
                <li className="c1 li-bullet-3">
                  <span className="c0">
                    not to use, display, mirror or frame the Platform, or any
                    individual element within the Platform, our name, any
                    RacketPal trade mark, logo or other proprietary information,
                    or the layout and design of any page or form contained on a
                    page, without our express written consent;
                  </span>
                </li>
                <li className="c1 li-bullet-3">
                  <span className="c0">
                    not to use any robot, spider, other automatic device or
                    manual process to monitor, download, copy or keep a database
                    copy of the content made available through the Platform;
                  </span>
                </li>
                <li className="c1 li-bullet-3">
                  <span className="c0">
                    not impersonate other people, including any employee or
                    representative of RacketPal; and
                  </span>
                </li>
                <li className="c1 li-bullet-3">
                  <span className="c0">
                    not to register, anywhere in the world, any intellectual
                    property rights belonging to RacketPal.
                  </span>
                </li>
              </ol>
              <ol className="c7 lst-kix_list_7-1" start={4}>
                <li className="c11 li-bullet-1">
                  <span className="c0">
                    Where applicable, Customer may link to the Platform,
                    provided Customer does so in a way that is fair and legal
                    and does not damage our reputation or take advantage of it.
                    Any link must not suggest any form of association, approval
                    or endorsement by RacketPal, where no such association,
                    approval or endorsement exists. RacketPal reserves the right
                    to withdraw any such linking permissions without notice.
                  </span>
                </li>
                <li className="c11 li-bullet-1">
                  <span className="c0">
                    If Customer chooses, or Customer is provided with, a user
                    identification code, password or any other piece of
                    information as part of the Platform's security procedures or
                    via setting up or accessing your Account, RacketPal
                    recommends that Customer treats such information as
                    confidential. RacketPal recommends that Customer does not
                    disclose any security information in relation to your
                    Account to any third party for any reason.
                  </span>
                </li>
                <li className="c11 li-bullet-1">
                  <span className="c0">
                    Customer is responsible for all activity undertaken on your
                    Account. Customer must also inform RacketPal immediately if
                    there has been any unauthorised usage of your Account.
                    RacketPal is not liable for any loss or damage suffered as a
                    result of any such unauthorised use unless such loss or
                    damage arises directly from RacketPal's failure to provide
                    the Platform with reasonable care and skill.
                  </span>
                </li>
              </ol>
              <ol className="c7 lst-kix_list_7-0" start={4}>
                <h4 className="mt-5">
                  <li className="c13 c9 li-bullet-0">
                    <span className="c5">RacketPal Premium services</span>
                  </li>
                </h4>
              </ol>
              <ol className="c7 lst-kix_list_7-1 start" start={1}>
                <li className="c3 c9 li-bullet-1">
                  <span className="c0">'</span>
                  <span className="c6 fw-bold">RacketPal Premium</span>
                  <span className="c0">
                    ' means additional subscription services (including
                    additional features or functionality) which are as described
                    on the Platform and can be purchased by Customer via the
                    Platform.
                  </span>
                </li>
                <li className="c3 li-bullet-2">
                  <span className="c10">&nbsp;</span>
                  <span className="c0">
                    When Customer places an order for RacketPal Premium via the
                    Platform, acceptance of this order takes place when
                    RacketPal Premium becomes available via your Account (and
                    this means that there is a legally binding contract in place
                    between Customer and RacketPal).
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    RacketPal Premium is available either: (i) on a rolling
                    subscription basis, with the options for subscription length
                    as set out on the Platform; or (ii) for as long as RacketPal
                    supports RacketPal Premium through payment of a one-off fee.
                    The subscription prices for RacketPal Premium are set out on
                    the Platform. All prices include sales tax at the applicable
                    rate.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    Payment of RacketPal Premium subscription is managed through
                    the relevant App Store. By purchasing RacketPal Premium via
                    the relevant App Store, Customer is required to agree to
                    that App Store's terms and conditions, which can be found
                    via the following links:
                  </span>
                </li>
              </ol>
              <p className="c15">
                <span className="c0">
                  Apple Store:
                  <a
                    href="https://www.apple.com/legal/internet-services/itunes/"
                    target="_blank"
                    rel="noreferrer"
                    className="text-primary">
                    https://www.apple.com/legal/internet-services/itunes/
                  </a>
                </span>
              </p>
              <p className="c15">
                <span className="c0">
                  Google Play Store:
                  <a
                    href="https://play.google.com/about/play-terms/index.html"
                    target="_blank"
                    rel="noreferrer"
                    className="text-primary">
                    https://play.google.com/about/play-terms/index.html
                  </a>
                </span>
              </p>
              <ol className="c7 lst-kix_list_7-1" start={5}>
                <li className="c3 li-bullet-2">
                  <span className="c0">
                    We have the right to reject a purchase of RacketPal Premium
                    for any reason. If we do need to reject a purchase, we will
                    notify Customer by email and if payment has already been
                    taken, Customer will be entitled to a full refund via the
                    relevant App Store.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    In certain circumstances we may need to stop providing
                    certain elements of RacketPal Premium. If this happens and
                    it affects Customer's purchase, we will notify Customer by
                    email and Customer will be entitled to a refund of any
                    unused part of their current RacketPal Premium subscription
                    via the relevant App Store.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    Customer can cancel its RacketPal Premium subscription
                    through the App Store at any time, and such cancellation
                    will take effect at the end of the current subscription
                    period.
                  </span>
                </li>
                <li className="c3 li-bullet-2">
                  <span className="c0">
                    RacketPal reserves the right to update its RacketPal Premium
                    subscription prices from time to time. We will notify
                    Customer of any price changes before they take effect.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    Customer will need access to the internet to access and use
                    RacketPal Premium, and Customer is responsible for any
                    charges that may be incurred in relation to its internet
                    connection. The quality of RacketPal Premium will depend on
                    the type of device being used, the device's resolution
                    settings and the internet connection speed being used to
                    connect to the Platform. RacketPal is not liable to Customer
                    if it is unable to use RacketPal Premium due to a poor
                    internet connection, because your device does not meet the
                    minimum technical requirements, or for any other reason
                    outside of our reasonable control.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    We cannot guarantee that any element of RacketPal Premium
                    will be available at any given time, or that access to
                    RacketPal Premium will be uninterrupted, error free or
                    secure. For example, access to RacketPal Premium may be
                    temporarily unavailable while we carry out maintenance or
                    for other technical reasons.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    Customer has 14 days from the date of the acceptance of the
                    order to change its mind and cancel your RacketPal Premium
                    order via the relevant App Store. However Customer loses
                    this right to cancel once it starts to use the RacketPal
                    Premium via its Account.
                  </span>
                </li>
                <li className="c3 c9 li-bullet-1">
                  <span className="c0">
                    Any RacketPal Premium services that we provide must be as
                    described, fit for purpose and satisfactory quality. If
                    there is another problem with RacketPal Premium, please
                    contact us as soon as reasonably possible.
                  </span>
                </li>
                <li className="c3 c9 li-bullet-2">
                  <span className="c0">
                    If RacketPal Premium is faulty, Customer is entitled to a
                    fix of the fault. If the fault cannot be fixed, or has not
                    been fixed within a reasonable time and without significant
                    inconvenient to Customer, Customer may be entitled to a full
                    or partial refund via the relevant App Store. This paragraph
                    sets out some of Customer's key rights. For more detailed
                    information visit the Citizens Advice website at
                    www.citizensadvice.org.uk.
                  </span>
                </li>
              </ol>
              <ol className="c7 lst-kix_list_7-0" start={5}>
                <h4 className="mt-5">
                  <li className="c13 c9 li-bullet-0">
                    <span className="c5">Intellectual property rights</span>
                  </li>
                </h4>
              </ol>
              <ol className="c7 lst-kix_list_7-1 start" start={1}>
                <li className="c3 c9 li-bullet-1">
                  <span className="c4">Services.</span>
                  <span className="c0">
                    &nbsp;RacketPal is the owner or the licensee of all
                    intellectual property rights in the Services and/or material
                    on the Platform (excluding any Customer Data contained in
                    the Services). RacketPal or its licensors own all
                    intellectual property rights in any data created by or on
                    behalf of RacketPal. All such rights are reserved. &nbsp;
                  </span>
                </li>
                <li className="c3 li-bullet-1" id="h.gjdgxs">
                  <span className="c4">Customer's use of the Services.</span>
                  <span className="c0">
                    &nbsp;Subject to compliance with these Terms, RacketPal
                    grants to Customer a limited, non-exclusive,
                    non-transferable, and non-sublicensable right to access and
                    use the applicable Services set out in these Terms for your
                    personal, non-commercial use.
                  </span>
                </li>
                <li className="c3 li-bullet-2">
                  <span className="c4">Information Customer provides.</span>
                  <span className="c0">
                    &nbsp;All intellectual property rights in information
                    Customer provides to RacketPal (including Customer Data)
                    shall remain owned by Customer or the relevant third-party
                    owner. By agreeing to these Terms, Customer grants RacketPal
                    a royalty-free, worldwide, transferable, non-exclusive,
                    perpetual, irrevocable and sub-licensable licence to
                    de-identify, use, copy or otherwise utilise the information
                    (including Customer Data) to the extent necessary or
                    desirable to perform or provide the Services and to improve
                    RacketPal's products and the Services (including training
                    artificial intelligence and machine learning technologies,
                    improving the Services, operations and systems, combining
                    data with other data sets, and/or deriving benchmarks and
                    other analysis and statistics). Any intellectual property
                    rights in data, analysis and improvements derived from
                    RacketPal's use of information Customer provides shall be
                    owned by RacketPal.
                  </span>
                </li>
                <li className="c3 li-bullet-2">
                  <span className="c4">Feedback.</span>
                  <span className="c0">
                    &nbsp;Customer grants to RacketPal a royalty-free,
                    worldwide, transferable, sub-licensable, irrevocable,
                    perpetual and non-exclusive license to use, copy or
                    otherwise utilise any feedback or content Customer sends to
                    RacketPal to the extent necessary to perform or provide the
                    Services and to improve RacketPal's products and Services
                    (including training artificial intelligence and machine
                    learning technologies, improving the Services, operations
                    and systems, combining data with other data sets, and/or
                    deriving benchmarks and other analysis and statistics).
                  </span>
                  <span className="c4">&nbsp;</span>
                </li>
              </ol>
              <ol className="c7 lst-kix_list_7-0" start={6}>
                <h4 className="mt-5">
                  <li className="c13 li-bullet-0">
                    <span className="c5">Limitation of liability</span>
                  </li>
                </h4>
              </ol>
              <ol className="c7 lst-kix_list_7-1 start" start={1}>
                <li className="c3 li-bullet-1" id="h.30j0zll">
                  <span className="c0">
                    RacketPal is responsible for loss or damage Customer suffers
                    that is a foreseeable result of RacketPal breaking its
                    contract with Customer or RacketPal's failing to use
                    reasonable care and skill. Loss or damage is foreseeable
                    when it is obvious that it will happen.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    RacketPal is not liable for any losses, or any failure or
                    delay in the performance of any obligations under these
                    Terms, due to any actions beyond its control.
                  </span>
                </li>
                <li className="c3 li-bullet-2">
                  <span className="c0">
                    To the maximum extent permitted by applicable law, RacketPal
                    shall not be liable or responsible to Customer for any
                    losses resulting from: (i) Customer breaching these Terms or
                    otherwise having acted unlawfully; or (ii) any legal or
                    regulatory requirement imposed on RacketPal.
                  </span>
                </li>
                <li className="c3 li-bullet-2">
                  <span className="c0">
                    RacketPal is not liable for business losses. RacketPal has
                    no liability to Customer for any loss of profit, loss of
                    business, business interruption, or loss of business
                    opportunity.
                  </span>
                </li>
                <li className="c3 li-bullet-1">
                  <span className="c0">
                    Where a Service is provided free of charge, RacketPal's
                    liability in respect of that Service (howsoever arising
                    under or in connection with these Terms) shall be limited to
                    £1,000.
                  </span>
                </li>
                <li className="c3 li-bullet-2">
                  <span className="c0">
                    Nothing in these Terms shall limit RacketPal's liability
                    for: (i) death or personal injury caused by its negligence;
                    (ii) fraud or fraudulent misrepresentation; or (iii) to the
                    extent liability cannot be excluded or limited under any
                    applicable law.
                  </span>
                </li>
              </ol>
              <ol className="c7 lst-kix_list_7-0" start={7}>
                <h4 className="mt-5">
                  <li className="c13 li-bullet-0">
                    <span className="c5">Other important information</span>
                  </li>
                </h4>
              </ol>
              <ol className="c7 lst-kix_list_7-1 start" start={1}>
                <li className="c11 li-bullet-2">
                  <span className="c4">Data protection.</span>
                  <span className="c0">
                    &nbsp;RacketPal will only use Customer's personal
                    information as set out in its privacy notice, which is
                    available via{" "}
                  </span>
                  <span className="c2">
                    <a
                      className="c8 text-primary"
                      href="https://www.racketpal.co.uk/privacy-policy">
                      www.racketpal.co.uk/privacy-policy
                    </a>
                  </span>
                  <span className="c0">.</span>
                </li>
                <li className="c11 li-bullet-1">
                  <span className="c4">Assignment and other dealings.</span>
                  <span className="c0">
                    &nbsp;RacketPal may at any time transfer its rights or
                    obligations under these Terms to another person upon a
                    written notification or a general notice on its website
                    and/or the Platform. Customer may only transfer its rights
                    or obligations under the Terms to another person if
                    RacketPal agrees to this in writing.
                  </span>
                </li>
                <li className="c11 li-bullet-1">
                  <span className="c4">Severability.</span>
                  <span className="c0">
                    &nbsp;Each of the sections and paragraphs of these Terms
                    operates separately. If any court or relevant authority
                    decides that any of them are unlawful or unenforceable, the
                    remaining sections and paragraphs will remain in full force
                    and effect.
                  </span>
                </li>
                <li className="c11 li-bullet-2">
                  <span className="c4">Variation.</span>
                  <span className="c0">
                    &nbsp;No variation of these Terms is effective unless in
                    writing and signed by RacketPal and Customer (or their
                    authorised representatives).
                  </span>
                </li>
                <li className="c11 li-bullet-1">
                  <span className="c4">Waiver.</span>
                  <span className="c0">
                    &nbsp;If Customer breaches these Terms and RacketPal takes
                    no action, or if RacketPal delays in taking action, that
                    does not mean that RacketPal has waived its rights and shall
                    be entitled to exercise its rights and remedies. If
                    RacketPal does waive a breach by Customer, RacketPal will
                    only do so in writing (signed by one of RacketPal's
                    Directors), and that shall not mean that RacketPal will
                    automatically waive any later breach by Customer.
                  </span>
                </li>
                <li className="c11 li-bullet-1">
                  <span className="c4">Complaints.</span>
                  <span className="c0">
                    &nbsp;RacketPal operates a complaints handling procedure
                    that will be used to try to resolve disputes when they first
                    arise. Customer should contact RacketPal if it has any
                    complaints or comments in relation to the Platform, using
                    the contact details given in these Terms.
                  </span>
                </li>
                <li className="c11 li-bullet-1">
                  <span className="c4">Third party rights.</span>
                  <span className="c0">
                    &nbsp;The Terms are between RacketPal and Customer. No other
                    person shall have any rights to enforce any of its terms.
                  </span>
                </li>
                <li className="c17 li-bullet-4">
                  <span className="c4">Entire agreement.</span>
                  <span className="c0">
                    &nbsp;These Terms constitute the entire agreement between
                    Customer and RacketPal and they supersede any and all
                    earlier agreements between Customer and RacketPal.
                  </span>
                </li>
                <li className="c17 li-bullet-4">
                  <span className="c4">Governing law and jurisdiction. </span>
                  <span className="c0">
                    These Terms are governed by English law and Customer can
                    bring legal proceedings in respect of the Terms in the
                    English courts. Additionally, if Customer is a consumer
                    living in Scotland, Customer can bring legal proceedings in
                    respect of the Terms in either the Scottish or the English
                    courts; or if Customer is a consumer living in Northern
                    Ireland, Customer can bring legal proceedings in respect of
                    the Terms in either the Northern Irish or the English
                    courts. &nbsp;
                  </span>
                </li>
              </ol>
              <p className="c12">
                <span className="c0" />
              </p>
              <p className="c20">
                <span className="c0">These Terms were published on </span>
                <span className="c16">27/02/</span>
                <span className="c0">2023.</span>
              </p>
              <p className="c12">
                <span className="c4" />
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default TermsAndConditions;
